/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryModel } from '../../models/country-model';

export interface CountryIdGet$Params {
  id: string;
}

export function countryIdGet(http: HttpClient, rootUrl: string, params: CountryIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<CountryModel>> {
  const rb = new RequestBuilder(rootUrl, countryIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<CountryModel>;
    })
  );
}

countryIdGet.PATH = '/Country/{id}';
